import Modal from "kustom-front/src/components/molecules/Modal";
import React, { FunctionComponent, useCallback, useEffect, useState } from "react";
import UpsellsMobile from "@Components/molecules/customization/Upsells/UpsellsMobile";
import UpsellsModal from "@Components/molecules/customization/Upsells/UpsellsModal";
import { useBreakpoint } from "@Hooks/useBreakpoint";
import { CheerzApiCustomizationSelectedProductOptions } from "@Types/api/customization";
import { UpsellIdentifiers, Upsell as UpsellType } from "@Types/upsells";

interface Props {
  displayUpsells: boolean;
  hideUpsells: () => void;
  onSubmit: (selectedUpsells: UpsellIdentifiers[]) => void;
  selectedUpsells: CheerzApiCustomizationSelectedProductOptions;
  upsells: UpsellType[];
}

const UpsellsContainer: FunctionComponent<Props> = ({
  displayUpsells,
  hideUpsells,
  onSubmit,
  selectedUpsells,
  upsells,
}) => {
  const { isSmallScreen } = useBreakpoint();

  const getSelectedUpsells = useCallback((): UpsellIdentifiers[] => {
    return Object.keys(selectedUpsells).map((tag) => {
      return { tag, value: selectedUpsells[tag].value };
    });
  }, [selectedUpsells]);

  const [selectedUpsellsTags, setSelectedUpsellsTags] = useState<UpsellIdentifiers[]>(
    getSelectedUpsells()
  );

  useEffect(() => {
    setSelectedUpsellsTags(getSelectedUpsells());
  }, [getSelectedUpsells]);

  const handleSelectUpsell = (selectedUpsell: UpsellIdentifiers) => {
    setSelectedUpsellsTags([...selectedUpsellsTags, selectedUpsell]);
  };

  const handleUnselectUpsell = (selectedUpsell: UpsellIdentifiers) => {
    setSelectedUpsellsTags(
      selectedUpsellsTags.filter(
        (upsellTag) =>
          upsellTag.tag !== selectedUpsell.tag || upsellTag.value !== selectedUpsell.value
      )
    );
  };

  const handleSubmitWithoutUpsell = () => {
    setSelectedUpsellsTags([]);
    onSubmit([]);
  };

  return (
    <>
      {isSmallScreen && displayUpsells ? (
        <UpsellsMobile
          hideUpsells={hideUpsells}
          onSelectUpsell={handleSelectUpsell}
          onSubmit={() => onSubmit(selectedUpsellsTags)}
          onSubmitWithoutUpsell={handleSubmitWithoutUpsell}
          onUnselectUpsell={(selectedUpsell: UpsellIdentifiers) =>
            handleUnselectUpsell(selectedUpsell)
          }
          selectedUpsellsTags={selectedUpsellsTags}
          upsells={upsells}
        />
      ) : (
        <Modal display={displayUpsells} onDismiss={hideUpsells} showCloseButton={false}>
          <UpsellsModal
            hideUpsells={hideUpsells}
            onSelectUpsell={handleSelectUpsell}
            onSubmit={() => onSubmit(selectedUpsellsTags)}
            onSubmitWithoutUpsell={handleSubmitWithoutUpsell}
            onUnselectUpsell={(selectedUpsell: UpsellIdentifiers) =>
              handleUnselectUpsell(selectedUpsell)
            }
            selectedUpsellsTags={selectedUpsellsTags}
            upsells={upsells}
          />
        </Modal>
      )}
    </>
  );
};

export default UpsellsContainer;
